import { formatPhoneNumber } from './formatPhoneNumber';
import { ERequestDemandField } from '../../../constants/requestDemand';

export const formatValue = (name: string, value: string) =>
  name === ERequestDemandField.PHONE ? formatPhoneNumber(value) : value;
